export const ROLES = {
    PSY: "psy",
    CLIENT: "client",
}

export type RoleType = (typeof ROLES)[keyof typeof ROLES]
